<div style="padding: 30px">
  <div class="close-icon" mat-button (click)="dialogRef.close()"></div>
  <div *ngIf="form" [formGroup]="form">
    <div class="control-item-component">
      <h2
        style="font-family: Roboto, 'Helvetica Neue', sans-serif;">Replace Text</h2>
      <div [formGroup]="form">
        <div style="display: flex; flex-direction: row;">
          <mat-form-field class="example-full-width">
            <mat-label>Find</mat-label>
            <input matInput formControlName="find">
          </mat-form-field>
        </div>
        <div style="display: flex; flex-direction: row;">
          <mat-form-field class="example-full-width">
            <mat-label>Replace</mat-label>
            <input matInput formControlName="replace">
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
  <div>
    <button mat-raised-button (click)="onReplace()" style="border-radius: 6px;">Replace</button>
    <button mat-raised-button style="border-radius: 6px;" (click)="onClose()">Cancel</button>
  </div>
  <div>{{message}}</div>
</div>
